import { estimateShotXg } from './gameStatsHelpers.js';

const finite = value => (typeof value === 'number' || (typeof value === 'string' && value.trim())) && Number.isFinite(Number(value)) ? Number(value) : null;
const probability = value => {
  const parsed = finite(value);
  return parsed !== null && parsed >= 0 && parsed <= 1 ? parsed : null;
};

export function recordedShotXg(shot) {
  if (!shot || typeof shot !== 'object') return null;
  for (const value of [shot.xg, shot.expectedGoals, shot.expected_goal,
    shot.metrics?.xg, shot.metrics?.expectedGoals, shot.model?.xg,
    shot.model?.expectedGoals, shot.model?.expected_goal, shot.analysis?.xg,
    shot.stats?.xg, shot.result?.xg, shot.result?.expectedGoals,
    shot.probabilities?.xg, shot.model?.result?.xg]) {
    const parsed = probability(value);
    if (parsed !== null) return parsed;
  }
  return null;
}

// Distinguish missing data from a real zero. Do not synthesize a shot from
// empty geometry objects or default coordinates.
export function ratingShotXg(shot, options = {}) {
  const recorded = recordedShotXg(shot);
  if (recorded !== null) return { xg: recorded, source: 'recorded' };
  if (finite(shot?.from?.x) === null || finite(shot?.from?.y) === null || finite(shot?.to?.x) === null) {
    return { xg: null, source: 'missing' };
  }
  const xg = probability(estimateShotXg(shot, options));
  return { xg, source: xg === null ? 'missing' : 'geometry-estimate' };
}

const onTargetMisses = new Set(['saved', 'blocked', 'block', 'rebound', 'deflect', 'deflected', 'tip', 'post-save', 'parried']);
const offTargetMisses = new Set(['offtarget', 'off-target', 'off_target', 'wide', 'miss', 'missed', 'out', 'off', 'post', 'bar', 'woodwork']);

export function ratingShotOutcome(shot) {
  const outcome = String(shot?.outcome ?? shot?.result?.outcome ?? '').trim().toLowerCase();
  if (shot?.goal === true || shot?.scored === true || outcome === 'goal') return 'goal';
  if (onTargetMisses.has(outcome)) return 'on_target_no_goal';
  if (offTargetMisses.has(outcome)) return 'off_target';
  // onTarget alone describes a trajectory, not a completed outcome.
  return 'unknown';
}
